const HvacIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M8.92969 8.9834H5.42285V7.4834H8.92969V8.9834Z"
      fill="currentColor"
    />
    <path
      d="M13.7148 8.9834H10.208V7.4834H13.7148V8.9834Z"
      fill="currentColor"
    />
    <path
      d="M18.5781 8.9834H15.0713V7.4834H18.5781V8.9834Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.1182 2.72949C21.532 2.72982 21.868 3.06559 21.8682 3.47949V10.8174C21.868 11.2313 21.532 11.5671 21.1182 11.5674H2.88281C2.46868 11.5674 2.13294 11.2315 2.13281 10.8174V3.47949C2.13294 3.06539 2.46868 2.72949 2.88281 2.72949H21.1182ZM3.63281 10.0674H20.3682V4.22949H3.63281V10.0674Z"
      fill="currentColor"
    />
  </svg>
);

export default HvacIcon;
